(function () {
  if (new URLSearchParams(window.location.search).get('claimdiscount') === 'true') {
    window.addEventListener('load', function () {
      setTimeout(function () {
        var target = document.getElementById('page-jump');
        if (target) {
          var elementRect = target.getBoundingClientRect();
          var absoluteTop = window.pageYOffset + elementRect.top;
          var offset = absoluteTop - (window.innerHeight / 2) + (elementRect.height / 2);
          window.scrollTo({ top: offset, behavior: 'smooth' });
        }
      }, 100);
    });
  }
})();